import request from '../request'

// 获取可查询的PD账号
// 返回值：
// "code": 200,
//     "msg": "操作成功",
//     "data": [
//         {
//             "idTrustedUser": 101916219,
//             "trustedUser": "Dan, 33"
//         },
//         {
//             "idTrustedUser": 101916473,
//             "trustedUser": "Xiang Ping, 43"
//         },
//         ...
//     ]
// }
export const getTrustedUsers = (data) => {
    return request({
        url: '/statistics/getTrustedUsers',
        method: 'POST',
        headers: {
            isEncrypt: false,
        },
        data
    })
}
// 获取收益明细
// 参数：
// {
//   "dateFrom": "2025-08-01",
//   "dateTo": "2025-08-08",
//   "groupByDate": 0,
//   "idTrustedUser": null,
//   "types": []
// }
// 返回值：
// {
//     "code": 200,
//     "msg": "操作成功",
//     "data": [
//         {
//             "trustedUser": "Phuong, 26",
//             "idTrustedUser": 84633140,
//             "bonuses": 4.31,
//             "bonusesList": {
//                 "chat_sticker": 4.31,
//                 "stream_watch": 4.31,
//                 "video_stream": 4.31,
//                 "chat_wink": 4.31,
//                 "acs_moderator_credits": 4.31,
//                 "chat_message": 4.31,
//                 "fines_compensation": 4.31,
//                 "correspondence_female_send": 4.31,
//                 "competition_vote": 4.31,
//                 "real_present_approved": 4.31,
//                 "donation": 4.31,
//                 "chat_photo": 4.31,
//                 "read_mail": 4.31,
//                 "chat_comment": 4.31,
//                 "contest_vote": 4.31,
//                 "virtual_gift": 4.31,
//                 "real_present_failed": 4.31,
//                 "correspondence_watch_attachment": 4.31,
//                 "mail_attachment_video": 4.31,
//                 "video_call": 4.31,
//                 "chat_audio": 4.31,
//                 "video_intro": 4.31,
//                 "chat_video": 4.31,
//                 "fine_no_video_verification": 4.31,
//                 "chat_post_read": 4.31
//             }
//         }
//     ]
// }
export const getStatisticByTypeAgency = (data) => {
    return request({
        url: '/statistics/getStatisticAccountByTypeAgency',
        method: 'POST',
        headers: {
            isEncrypt: false,
        },
        data
    })
}

// 获取当前账号的收益
// /statistics/getPdStatisticsList
// 参数：
// {
//     "startDate": "2025-08-27",
//     "endDate": "2025-08-28"
// }
export const getPdStatisticsList = (data) => {
    return request({
        url: '/statistics/getPdStatisticsList',
        method: 'POST',
        headers: {
            isEncrypt: false,
        },
        data
    })
}